import { reactive } from 'vue';

export default {
  name: 'PurchaseProductSelectComponent',
  props: {
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false
    }
  },
  setup() {
    const state = reactive({

    });

    const formatPrice = (cents) => {
      const dollars = (cents / 100).toFixed(2);
      const parts = dollars.split(".");
      if (parts[1] === "00") {
        return `$${parts[0]}`;
      }
      return `$${dollars}`;
    };

    return { state, formatPrice };
  },
  methods: {
    change: async function (product) {
      this.$emit('product-change', product);
    },
    next: async function () {
      this.$emit('next');
    }
  }
};